import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previewPages } from '../data/previewPages';
const EASE = [0.23, 1, 0.32, 1] as const;
export function InsideLook() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const total = previewPages.length;
  const page = previewPages[index];
  const go = (step: number) => {
    setDirection(step);
    setIndex(prev => (prev + step + total) % total);
  };
  return <section id="anteprima" className="w-full overflow-hidden bg-navy px-5 py-20 sm:py-28" data-id="element-127" data-mp="2uypf0gpwnoo3">
      <div className="mx-auto max-w-5xl" data-id="element-128" data-mp="2h7u3sxrxovhc">
        <div className="text-center" data-id="element-129" data-mp="2m6xcqtb1blul">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-ochre" data-id="element-130" data-mp="2m5vxsdqwef7l">
            Sbircia dentro il materiale
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-white sm:text-[2.6rem]" data-id="element-131" data-mp="3en81urnfupzm">
            Pagine vere, <span className="italic text-ochre" data-id="element-132" data-mp="21wou0y9e1qeh">non promesse.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-white/60" data-id="element-133" data-mp="1xvbqiutrpzaq">
            Queste sono schede reali estratte dai volumi: guarda la qualità che
            porterai in classe già domani mattina.
          </p>
        </div>

        <div className="mt-12 grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_20rem] md:gap-12" data-id="element-134" data-mp="26svvoeur4fqm">
          <div className="relative mx-auto w-full max-w-sm md:max-w-md" data-id="element-135" data-mp="2llpkwrztsa8h">
            <div className="relative aspect-[9/14] w-full overflow-hidden rounded-3xl bg-white shadow-[0_30px_60px_-30px_rgba(0,0,0,0.7)]" data-id="element-136" data-mp="2gk9wcpyfvllc">
              <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-137" data-mp="2plgfl6sh3aia">
                <motion.img key={page.image} src={page.image} alt={`Anteprima della pagina: ${page.title}`} custom={direction} initial={{
                opacity: 0,
                x: direction * 40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction * -40
              }} transition={{
                duration: 0.28,
                ease: EASE
              }} className="absolute inset-0 h-full w-full object-cover object-top" data-id="element-138" data-mp="2pjnbnz98v4dz" />
              </AnimatePresence>
            </div>

            <button type="button" onClick={() => go(-1)} aria-label="Pagina precedente" className="absolute -left-3 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-lg transition-colors duration-150 hover:bg-tangerine hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-tangerine/40 sm:-left-5" data-id="element-139" data-mp="397d5r0r8v2ya">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-140" data-mp="3swnj483ipbt8" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Pagina successiva" className="absolute -right-3 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-lg transition-colors duration-150 hover:bg-tangerine hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-tangerine/40 sm:-right-5" data-id="element-141" data-mp="v8yloinztu5">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-142" data-mp="1hawi4u18yuo3" />
            </button>
          </div>

          <div className="text-center md:text-left" data-id="element-143" data-mp="1ccl8ajayck5v">
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-ochre" data-id="element-144" data-mp="29118d9boubx8">
              {page.tag}
            </span>
            <h3 className="mt-3 font-display text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-145" data-mp="250z5wxy4pegw">
              {page.title}
            </h3>
            <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-white/60 md:mx-0" data-id="element-146" data-mp="1v9w5lyd0x3io">
              {page.text}
            </p>

            <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.18em] text-white/40" data-id="element-147" data-mp="2sqbp8qn672wx">
              Pagina {index + 1} di {total}
            </p>

            <div className="mt-4 flex justify-center gap-3 md:justify-start" role="tablist" aria-label="Anteprime delle pagine" data-id="element-148" data-mp="27j0zewxmjrhv">
              {previewPages.map((item, i) => <button key={item.image} type="button" role="tab" aria-selected={i === index} aria-label={item.title} onClick={() => {
              setDirection(i > index ? 1 : -1);
              setIndex(i);
            }} className={`h-14 w-10 overflow-hidden rounded-md border-2 transition-colors duration-150 focus:outline-none focus-visible:ring-4 focus-visible:ring-tangerine/40 ${i === index ? 'border-tangerine' : 'border-white/15 opacity-50 hover:opacity-100'}`} data-id="element-149" data-mp="2cjoze83tzio8" data-mpi={i}>
                  <img src={item.image} alt="" className="h-full w-full object-cover object-top" data-id="element-150" data-mp="2hg5p36qoi53f" />
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}